import gql from 'graphql-tag';
import React from 'react';
import { Text } from '../../components';
import { getFullMachineName } from '../../../common/utils/machine';
import SearchDropdownSelector from './SearchDropdownSelector';

const GET_MACHINES = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: MachinePageFilter
	) {
		getMachines(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				assetId
				place {
					id
					name
				}
				location {
					id
					name
				}
			}
			count
		}
	}
`;


const MachineSelector = (props) => {

	const { query } = props;

	return (
		<SearchDropdownSelector
			query={query || GET_MACHINES}
			renderItem={item => <Text>{ getFullMachineName(item, item.place, item.location) }</Text>}
			renderLabel={item => <Text>{ getFullMachineName(item, item.place, item.location) }</Text>}
			placeholder="Select machine"
			{...props}
		/>
	);
};

export default MachineSelector;
